import { Routes } from '@angular/router'
import { isAuthenticated } from '../../core/auth/guards/auth.guard'
import { canActivateAuthRole } from '../../core/auth/guards/role.guard'
// TKT-79640: مرحله انتخاب نقش/احراز هویت ثبت دوره به‌صورت موقت غیرفعال است؛
// فعال‌سازی مجدد فقط با تغییر flag در همین فایل config انجام می‌شود.
import { COURSE_REGISTRATION_ROUTE_ROLES } from './course-ad-wizard/course-registration.config'

export const adsRoutes: Routes = [
	{
		path: 'ads',
		canActivate: [isAuthenticated],
		loadComponent: () => import('../../layout/main-layout/main-layout'),
		data: {
			role: '',
			title: 'Ads Dashboard',
			breadcrumb: 'AdsDashboard',
			preload: true,
			roles: [''],
		},
		children: [
			// {
			// 	path: 'gateways',
			// 	loadComponent: () => import('./gateway-management/gateway-management'),
			// 	title: 'gateways_manage',
			// },

			{
				path: 'ad',
				loadComponent: () => import('./ad/ad.component'),
				data: {
					title: 'Admin Dashboard',
					breadcrumb: 'Dashboard',
					icon: 'admin-dashboard',
					preload: true,
					roles: [''],
				},
			},
			{
				path: 'space-rental-ad',
				canActivate: [canActivateAuthRole],
				loadComponent: () => import('./space-rental-ad/space-rental-ad.component'),
				data: {
					title: 'ثبت آگهی اجاره فضا',
					breadcrumb: 'ثبت آگهی اجاره فضا',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SALON_ADMIN', 'CLINIC_ADMIN'],
				},
			},
			{
				path: 'adsList',
				loadComponent: () => import('../public/space-rental-list/space-rental-list'),
				data: {
					title: 'Admin Dashboard',
					breadcrumb: 'Dashboard',
					icon: 'admin-dashboard',
					preload: true,
					roles: [''],
				},
			},
			{
				path: 'my-ads',
				loadComponent: () => import('./my-ads/my-ads'),
				data: {
					title: 'Admin Dashboard',
					breadcrumb: 'Dashboard',
					icon: 'admin-dashboard',
					preload: true,
					roles: [''],
				},
			},
			{
				// Marketplace: seller's own equipment ads (list / pay / renew / duplicate).
				path: 'my-equipments',
				loadComponent: () => import('./my-equipments/my-equipments'),
				data: {
					title: 'تجهیزات من',
					breadcrumb: 'تجهیزات من',
					roles: ['SALON_ADMIN', 'SELLER_USER', 'CLINIC_ADMIN', 'TRAINER_USER', 'SUPER_ADMIN'],
				},
			},
			{
				// Academy M2: course creation wizard (server-side draft).
				path: 'course-ad',
				canActivate: [canActivateAuthRole],
				loadComponent: () => import('./course-ad-wizard/course-ad-wizard'),
				data: {
					title: 'ثبت دوره آموزشی',
					breadcrumb: 'ثبت دوره',
					// flag: COURSE_REGISTRATION_ROUTE_ROLES — [] یعنی هر کاربر واردشده.
					roles: COURSE_REGISTRATION_ROUTE_ROLES,
				},
			},
			{
				// Marketplace M1: equipment ad creation wizard (server-side draft).
				path: 'equipment-ad',
				canActivate: [canActivateAuthRole],
				loadComponent: () => import('./equipment-ad-wizard/equipment-ad-wizard'),
				data: {
					title: 'ثبت آگهی تجهیزات',
					breadcrumb: 'ثبت آگهی تجهیزات',
					roles: ['SALON_ADMIN', 'SELLER_USER', 'CLINIC_ADMIN', 'TRAINER_USER', 'SUPER_ADMIN'],
				},
			},
			{
				// Academy M5: my submitted reviews (+ instructor replies).
				path: 'my-reviews',
				loadComponent: () => import('./my-reviews/my-reviews'),
				data: { title: 'نظرات من', breadcrumb: 'نظرات من', roles: [''] },
			},
			{
				// Academy M4: user's favorited ads (courses + spaces).
				path: 'favorites',
				loadComponent: () => import('./favorites/favorites'),
				data: { title: 'علاقه‌مندی‌ها', breadcrumb: 'علاقه‌مندی‌ها', roles: [''] },
			},
			{
				// Academy M2: instructor's course management panel.
				path: 'my-courses',
				loadComponent: () => import('./my-courses/my-courses'),
				data: {
					title: 'دوره‌های من',
					breadcrumb: 'دوره‌های من',
					roles: [''],
				},
			},
			{
				// Marketplace M5: escrow transactions panel (buyer/seller switch + tabs).
				path: 'secure-transactions',
				loadComponent: () => import('./secure-transactions/secure-transactions'),
				data: {
					title: 'معاملات امن من',
					breadcrumb: 'معاملات امن',
					roles: [''],
				},
			},
			{
				// Marketplace M5: single escrow transaction — timeline, snapshot, actions.
				path: 'secure-transactions/:id',
				loadComponent: () => import('./secure-transactions/secure-transaction-details'),
				data: {
					title: 'جزئیات معامله امن',
					breadcrumb: 'جزئیات معامله',
					roles: [''],
				},
			},
			{
				// Academy M1: instructor public profile + professional verification.
				path: 'instructor-profile',
				loadComponent: () => import('./instructor-profile-edit/instructor-profile-edit'),
				data: {
					title: 'پروفایل مدرس',
					breadcrumb: 'پروفایل مدرس',
					roles: [''],
				},
			},
			{
				path: 'ad-promote',
				loadComponent: () => import('./ad-promote/ad-promote'),
				data: {
					title: 'ارتقای آگهی',
					breadcrumb: 'ارتقای آگهی',
					roles: [''],
				},
			},
			{
				path: 'payment-history',
				loadComponent: () => import('./payment-history/payment-history'),
				data: {
					title: 'تاریخچه پرداخت‌ها',
					breadcrumb: 'پرداخت‌ها',
					roles: [''],
				},
			},

			// Base Information Management
			// {
			// 	path: 'goods-category',
			// 	loadComponent: () => import('./baseInformation/goods-category/goods-category'),
			// 	data: {
			// 		title: 'Goods Category',
			// 		breadcrumb: 'Goods Category',
			// 		icon: 'category',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'stock-symbol',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./baseInformation/stock-symbol/stock-symbol'),
			// 			data: {
			// 				title: 'Stock Symbols',
			// 				breadcrumb: 'Stock Symbols',
			// 				icon: 'stock',
			// 			},
			// 		},
			// 		{
			// 			path: 'add',
			// 			loadComponent: () => import('./baseInformation/stock-symbol/add-stock-symbol/add-stock-symbol'),
			// 			data: {
			// 				title: 'Add Stock Symbol',
			// 				breadcrumb: 'Add Stock',
			// 			},
			// 		},
			// 		{
			// 			path: 'edit/:id',
			// 			loadComponent: () => import('./baseInformation/stock-symbol/add-stock-symbol/add-stock-symbol'),
			// 			data: {
			// 				title: 'Edit Stock Symbol',
			// 				breadcrumb: 'Edit Stock',
			// 			},
			// 		},
			// 	],
			// },
			//
			// // Price Configuration
			// {
			// 	path: 'release-goods-from-warehouse-price-config',
			// 	loadComponent: () =>
			// 		import(
			// 			'./baseInformation/release-goods-from-warehouse-price-config/release-goods-from-warehouse-price-config'
			// 		),
			// 	data: {
			// 		title: 'Release Price Config',
			// 		breadcrumb: 'Release Price',
			// 		icon: 'price-config',
			// 	},
			// },
			// {
			// 	path: 'goods-to-warehousing-price-config',
			// 	loadComponent: () =>
			// 		import('./baseInformation/goods-to-warehousing-price-config/goods-to-warehousing-price-config'),
			// 	data: {
			// 		title: 'Warehousing Price Config',
			// 		breadcrumb: 'Warehousing Price',
			// 		icon: 'warehouse-price',
			// 	},
			// },
			// {
			// 	path: 'lab-analysis-price-config',
			// 	loadComponent: () => import('./baseInformation/lab-analysis-price-config/lab-analysis-price-config'),
			// 	data: {
			// 		title: 'Lab Analysis Price Config',
			// 		breadcrumb: 'Lab Analysis Price',
			// 		icon: 'lab-price',
			// 	},
			// },
			// {
			// 	path: 'legal-users-management',
			// 	loadComponent: () => import('./legal-users-management/legal-users-management'),
			// 	data: {
			// 		roles: ['ADMIN'],
			// 		preload: true,
			// 	},
			// },
			// // User Management
			// {
			// 	path: 'users-management',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./user-management/user-management'),
			// 			data: {
			// 				title: 'Users Management',
			// 				breadcrumb: 'Users',
			// 				icon: 'users',
			// 				preload: true,
			// 				roles: ['ADMIN'],
			// 			},
			// 		},
			// 		{
			// 			path: 'add',
			// 			loadComponent: () => import('./user-management/add-user/add-user'),
			// 			data: {
			// 				title: 'Add User',
			// 				breadcrumb: 'Add User',
			// 			},
			// 		},
			// 		{
			// 			path: 'edit/:id',
			// 			loadComponent: () => import('./user-management/add-user/add-user'),
			// 			data: {
			// 				title: 'Edit User',
			// 				breadcrumb: 'Edit User',
			// 			},
			// 		},
			// 	],
			// },
			// {
			// 	path: 'money-request',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./money-request/money-request'),
			// 			data: {
			// 				title: 'Users Management',
			// 				breadcrumb: 'Users',
			// 				icon: 'users',
			// 				preload: true,
			// 				roles: ['ADMIN'],
			// 			},
			// 		},
			// 	],
			// },
			// {
			// 	path: 'money-wallet-pay-by-id',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./money-wallet-pay-by-id/money-wallet-pay-by-id'),
			// 			data: {
			// 				title: 'Users Management',
			// 				breadcrumb: 'Users',
			// 				icon: 'users',
			// 				preload: true,
			// 				roles: ['ADMIN'],
			// 			},
			// 		},
			// 	],
			// },
			//
			// // Reports
			// {
			// 	path: 'money-wallet',
			// 	loadComponent: () => import('./reports/admin/money-wallet/money-wallet'),
			// 	data: {
			// 		title: 'Money Wallet Report',
			// 		breadcrumb: 'Money Wallet',
			// 		icon: 'wallet-report',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'trade',
			// 	loadComponent: () => import('./reports/admin/trade/trade'),
			// 	data: {
			// 		title: 'Trade Report',
			// 		breadcrumb: 'Trade Report',
			// 		icon: 'trade-report',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'orders',
			// 	loadComponent: () => import('./reports/admin/orders/orders'),
			// 	data: {
			// 		title: 'Orders Report',
			// 		breadcrumb: 'Orders Report',
			// 		icon: 'orders-report',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			//
			// // Agreement Templates
			// {
			// 	path: 'agreement-templates',
			// 	loadComponent: () =>
			// 		import('./admin/agreement-templates/agreement-templates').then(m => m.AgreementTemplatesComponent),
			// 	data: {
			// 		title: 'Agreement Templates',
			// 		breadcrumb: 'Agreements',
			// 		icon: 'agreement',
			// 	},
			// },

			// Goods Management (shared with trading)
			// {
			// 	path: 'good-to-warehouse',
			// 	loadComponent: () => import('./goods-management/good-to-warehouse'),
			// 	data: {
			// 		title: 'Good to Warehouse',
			// 		breadcrumb: 'Good to Warehouse',
			// 		icon: 'goods-warehouse',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'good-to-warehouse/goods-bundle-lab-analysis/:goodsToWarehouseId',
			// 	loadComponent: () => import('./goods-management/goods-bundle-lab-analysis-list/goods-bundle-lab-analysis-list'),
			// 	data: {
			// 		title: 'Lab Analysis',
			// 		breadcrumb: 'Lab Analysis',
			// 	},
			// },
			// User Profile
			{
				path: 'profile',
				loadComponent: () => import('../trading/profile/profile'),
				data: {
					title: 'Profile',
					breadcrumb: 'Profile',
					icon: 'user',
				},
			},
			// Default redirect
			{
				path: '',
				redirectTo: 'admin-dashboard',
				pathMatch: 'full',
			},
		],
	},
]
